import { createTheme } from '@mui/material/styles';
import { Theme, CSSObject } from '@mui/material';


export const createCartoonButtonStyles = (color: string, theme: Theme): CSSObject => ({
  background: color,
  border: `4px solid ${theme.palette.grey[800]}`,
  borderRadius: '15px',
  boxShadow: `0 5px 0 ${theme.palette.grey[800]}, 0 10px 10px ${theme.palette.grey[600]}`,
  color: theme.palette.common.white,
  fontSize: '16px',
  fontWeight: 'bold',
  height: '50px',
  padding: '10px 20px',
  textShadow: '1px 1px 0 #000',
  transition: 'all 0.2s',
  '&:hover': {
    filter: 'brightness(1.3)',
    transform: 'translateY(-5px)',
    boxShadow: `0 10px 0 ${theme.palette.grey[800]}, 0 10px 30px ${theme.palette.grey[600]}`,
  },
});

export const createCartoonTextStyles = (theme: Theme): CSSObject => ({
  border: `4px solid ${theme.palette.grey[800]}`,
  borderRadius: '15px',
  boxShadow: `0 5px 0 ${theme.palette.grey[800]}, 0 10px 10px ${theme.palette.grey[600]}`,
  color: theme.palette.common.white,
  fontSize: '16px',
  fontWeight: 'bold',
  // padding: '10px 20px',
  textShadow: '1px 1px 0 #000',
  transition: 'all 0.2s',
  '&:hover': {
    filter: 'brightness(1.3)',
    transform: 'translateY(-5px)',
    boxShadow: `0 10px 0 ${theme.palette.grey[800]}, 0 10px 30px ${theme.palette.grey[600]}`,
  },
});


const theme = createTheme({
  palette: {
    primary: {
      main: '#ff4081',  // Vibrant pink
    },
    secondary: {
      main: '#3f51b5',  // Blue
    },
    background: {
      default: 'linear-gradient(135deg, #FF6F61 30%, #6B5B95 90%)',
    },
  },
  typography: {
    button: {
      fontFamily: '"Comic Sans MS", cursive, sans-serif',
    },
    fontFamily: '"Comic Sans MS", cursive, sans-serif', // Set as default font
    fontSize: 16,

  },
});

export default theme;
